export default __webpack_public_path__ + "static/media/RPG_7.1253a2db.png";